import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Checkbox } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import {
    StyledScoreContainer,
    StyledScoreItem,
    StyledStarIcon,
    StyledStarsContainer,
} from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsRatingFilter/components/Score/styles";
import { StyledFilterHeading } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsRatingFilter/styles";
import type FindAppsRatingFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/RatingFilter";

export const Score: FC<IFilterViewBaseProps<FindAppsRatingFilter>> = ({ onFilterUpdate, value, filter }) => {
    const handleItemSelect = (item: number, selected: boolean) => {
        if (selected) {
            onFilterUpdate({ ...value, score: [...(value?.score ?? []), item] });
            return;
        }

        onFilterUpdate({ ...value, score: value?.score?.filter((v) => v !== item) });
    };

    const renderStars = (score: number) =>
        Array.from({ length: filter.scoreOptions.length - 1 }, (_, index) => (
            <StyledStarIcon
                key={index}
                iconName="star"
                size="xs"
                color={index + 1 <= score ? colorsPalettes.solutions.SALES : colorsPalettes.midnight[100]}
            ></StyledStarIcon>
        ));

    const renderItems = () =>
        filter.scoreOptions.map((option) => {
            const isSelected = Boolean(value?.score?.includes(option));
            return (
                <StyledScoreItem key={option}>
                    <Checkbox
                        onClick={() => handleItemSelect(option, !isSelected)}
                        selected={isSelected}
                    />
                    <StyledStarsContainer>
                        {option === 0 ? (
                            <Text
                                fontVariant="body2"
                                color={colorsPalettes.carbon[500]}
                            >
                                {translate("si.find_apps.filters.rating.select_rating.not_rated")}
                            </Text>
                        ) : (
                            renderStars(option)
                        )}
                    </StyledStarsContainer>
                </StyledScoreItem>
            );
        });

    return (
        <>
            <StyledFilterHeading>{translate("si.find_apps.filters.rating.select_rating.heading")}</StyledFilterHeading>
            <StyledScoreContainer>{renderItems()}</StyledScoreContainer>
        </>
    );
};
